import { apiURL, callAPI } from 'api/main';

interface IAcceptInviteParams {
  matchId: string;
  dateId: string;
}

export default async (params: IAcceptInviteParams): Promise<any> => {
  try {
    const res = await callAPI({
      url: `${apiURL}/v3/sys/match/invites/accept`,
      method: 'POST',
      needToken: true,
      params: {
        matchId: +params.matchId,
        dateId: +params.dateId,
      },
    });

    const data = res.request;

    if (data) {
      return data;
    }

    null;
  } catch (ex) {
    return null;
  }
};
